import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'

import { ImportacaoDetalhePage } from './detalhes/ImportacaoDetalhePage'
import { ImportacaoErroPage } from './erros/ImportacaoErroPage'
import { ImportacaoListPage } from './list/ImportacaoListPage'

const importacoesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Importação',
    path: '/apps/importacao/lista',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ImportacaoPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='lista'
          element={
            <>
              <PageTitle description={t('pagina.importacao.descricao')}>
                {t('importacao.label')}
              </PageTitle>
              <ImportacaoListPage />
            </>
          }
        />
        <Route
          path='erros/:id'
          element={
            <>
              <PageTitle breadcrumbs={importacoesBreadcrumbs}>Erros importação</PageTitle>
              <ImportacaoErroPage />
            </>
          }
        />
        <Route
          path='detalhes/:id'
          element={
            <>
              <PageTitle breadcrumbs={importacoesBreadcrumbs}>Detalhes importação</PageTitle>
              <ImportacaoDetalhePage />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/importacao/lista' />} />
    </Routes>
  )
}

export default ImportacaoPage
